import React from "react";
import { ActionProps } from "react-querybuilder";

export const CustomCloneGroupAction: React.FC<ActionProps> = (props) => {
    return null;
};
